module.exports = __webpack_public_path__ + "static/media/photo-1548867688-231911e4ba3c.553ff77b.jpg";